export const CustomEventType = {
  Mute: "mute",
  SlotWin: "slot_win",
};
